import React from "react";
import { Link } from "react-router-dom";
import { FaWhatsapp, FaRocket } from "react-icons/fa";
import profile from "../../data/profile";
import Type from "./Type";

function Hero() {
  return (
    <div className="hero-banner glass-card">
      <div className="freelance-badge">
        <span className="freelance-dot"></span> Available for Freelance Work
      </div>
      <h1>
        Bridging Infrastructure &amp;{" "}
        <span className="gradient-text">Development in the Cloud.</span>
      </h1>
      <p>{profile.basics.summary}</p>
      <div style={{ fontFamily: "var(--font-sans)", fontSize: "1.15rem", marginBottom: 24 }}>
        <Type />
      </div>
      <div className="hero-cta">
        <a
          href={profile.basics.whatsapp}
          target="_blank"
          rel="noreferrer"
          className="btn btn-hire"
        >
          <FaWhatsapp /> Hire Me
        </a>
        <Link to="/project" className="btn btn-outline">
          <FaRocket /> View My Work
        </Link>
      </div>
      <div className="hero-stats">
        <div className="hero-stat">
          <span className="stat-value">2.8+</span>
          <span className="stat-label">Years Experience</span>
        </div>
        <div className="hero-stat">
          <span className="stat-value">15+</span>
          <span className="stat-label">Projects Done</span>
        </div>
        <div className="hero-stat">
          <span className="stat-value">4+</span>
          <span className="stat-label">Clients Served</span>
        </div>
        <div className="hero-stat">
          <span className="stat-value">24/7</span>
          <span className="stat-label">Support</span>
        </div>
      </div>
    </div>
  );
}

export default Hero;